import { UpdateOp } from './types';
import { mapIf } from './utils';

type IUpdateAtIndex <T> = (
  itemIndex: number, updateOp: UpdateOp<T>,
  options?: { updateOthers?: UpdateOp<T> }
) => void;

type IDeleteAtIndex <T> = (
  itemIndex: number,
  options?: { updateOthers?: UpdateOp<T> }
) => void;

type ISetItems <T> = (initialItems: Array<T>) => void;

interface IListStateHandler <T> {
  setItems: ISetItems <T>,
  updateAtIndex: IUpdateAtIndex <T>,
  deleteAtIndex: IDeleteAtIndex <T>,
}

export function listStateHandler<T>(
  [items, setItems]: [Array<T>, React.Dispatch<React.SetStateAction<Array<T>>>],
): [Array<T>, IListStateHandler <T>] {
  const wrappedSetItems = {
    setItems: (initialItems: Array<T>) => setItems(initialItems),
    updateAtIndex: (
      itemIndex: number,
      updateOp: UpdateOp<T>,
      options?: { updateOthers?: UpdateOp<T> },
    ) => setItems([...updatedStateItemAtIndex(items, itemIndex, updateOp, options)]),
    deleteAtIndex: (
      itemIndex: number,
      options?: { updateOthers?: UpdateOp<T> },
    ) => setItems([...deleteStateItemAtIndex(items, itemIndex, options)]),
  };

  return [items, wrappedSetItems];
}

export function addStateItemAtIndex<T>(
  items: Array<T>, itemIndex: number, updateOp: UpdateOp<T>,
  { updateOthers }: { updateOthers?: UpdateOp<T> } = {},
): Array<T> {
  return [
    ...mapIf(items.slice(0, itemIndex), updateOthers),
    updateOp(items[itemIndex]),
    ...mapIf(items.slice(itemIndex + 1, items.length), updateOthers),
  ];
}

export function updatedStateItemAtIndex<T>(
  items: Array<T>, itemIndex: number, updateOp: UpdateOp<T>,
  { updateOthers }: { updateOthers?: UpdateOp<T> } = {},
): Array<T> {
  return [
    ...mapIf(items.slice(0, itemIndex), updateOthers),
    updateOp(items[itemIndex]),
    ...mapIf(items.slice(itemIndex + 1, items.length), updateOthers),
  ];
}

export function deleteStateItemAtIndex<T>(
  items: Array<T>, itemIndex: number, { updateOthers }: { updateOthers?: UpdateOp<T> } = {},
): Array<T> {
  return [
    ...mapIf(items.slice(0, itemIndex), updateOthers),
    ...mapIf(items.slice(itemIndex + 1, items.length), updateOthers),
  ];
}

export default {};
